
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crew-texts",
      function () {
        return require("private-next-pages/crew-texts.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crew-texts"])
      });
    }
  